import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { SerializedAccountTracker } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { TrackerMark } from './TrackerMark';
import { trackerProviderMark } from './trackerProviders';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './SMLTrackers.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TrackerRowProps {
  tracker: SerializedAccountTracker;
  onRemove: (tracker: SerializedAccountTracker) => void;
}

/** One tracker: what it is, which id it fires, and the way out. */
const TrackerRowComponent: React.FC<TrackerRowProps> = ({ tracker, onRemove }) => {
  const intl = useIntl();
  const mark = trackerProviderMark(tracker.type);

  const remove = useCallback(() => onRemove(tracker), [onRemove, tracker]);

  if (mark === undefined) {
    return null;
  }

  return (
    <div className={styles.row}>
      <TrackerMark mark={mark} size="row" />
      <div className={styles.rowInfo}>
        <span className={styles.rowName}>{mark.name}</span>
        <span className={styles.rowId}>{tracker.trackerId}</span>
      </div>
      <span className={styles.rowDate}>
        {intl.formatMessage(
          { id: 'app.sml.trackers.row.added', defaultMessage: 'added {date}' },
          { date: intl.formatDate(tracker.createdAt, { day: 'numeric', month: 'short' }) }
        )}
      </span>
      <button
        type="button"
        className={styles.remove}
        onClick={remove}
        aria-label={intl.formatMessage({ id: 'app.sml.trackers.row.remove', defaultMessage: 'Remove tracker' })}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const TrackerRow = TypedMemo(TrackerRowComponent);
